import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { ShortCodeHistoryResult, ShortCodesService } from 'src/app/services/shortcodes.service';
import { Router } from '@angular/router';
import { ScrBaseService } from 'src/app/services/base.service';
import { ReportSuspiciousActivity, TypeCode, ReportSuspiciousActivityRequest } from 'src/app/models/shortcodes.model';
import { Aggregator, ConfigService, Config } from 'src/app/services';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { SelectItem } from 'primeng/api';



@Component({
  selector: 'app-report-suspicious-activity',
  templateUrl: './report-suspicious-activity.component.html',
  styleUrls: ['./report-suspicious-activity.component.scss']
})
export class ReportSuspiciousActivityComponent extends ScrBaseComponent implements OnInit {
  @ViewChild('form1', { static: true }) activityForm: NgForm | undefined;

  shortCodeValue!: string;
  shortCodeDisplay?: string;
  shortCodeStatus?: string;
  apiMessage?: string;
  searchShortCodeValue = '';
  shortCodeHistory?: ShortCodeHistoryResult;
  showData = false;
  isErrorLinkVisible = false;
  preErrorMessage = '';
  errorDisplayShortCode = '';
  errorMessage?: string;
  model = new ReportSuspiciousActivity();
  isDisplay = false;
  isInputDisabled = false;
  public aggregators: Aggregator[] = [];
  public activityTypes: TypeCode[] = [];
  isSearchDisabled = false;
  public brandClients: SelectItem[] = [];
  
  // MaxCharactorsForLine=120;
  // MaxLines=50;

  constructor(private shortCodesService: ShortCodesService,
    private router: Router,
    public configService: ConfigService) {
    super();
  }
  ngOnInit(): void {
    if (history.state?.shortCode) {
      this.shortCodeValue = history.state.shortCode;
    }
    this.configService.getAggregators().subscribe(res => {
      this.aggregators = res.filter(aggregator => aggregator.aggregatorId !== 9999);
    });
    this.configService.getSuspiciousActivityConfig().subscribe(res => {
      if (res.activityTypes) {
        res.activityTypes.forEach((val) => {
          const type = new TypeCode();
          type.code = val;
          type.description = val;
          this.activityTypes.push(type);
          this.activityTypes.sort((a, b) => a.description.localeCompare(b.description));
        });
      }
    });
    this.configService.getConfig().subscribe((cfg: Config) => {
      this.customerSupportPhone = cfg.customerSupportPhone;
    });
  }

  submit(form: NgForm) {
    this.clearMessages();
    if (!form.valid) {
      this.scrollToFirstError();
      return;
    }
    this.activityForm?.resetForm();
    this.validateShortCode();
  }

  validateShortCode(): void {
    this.shortCodeDisplay = '';
    this.apiMessage = '';
    this.searchShortCodeValue = ScrBaseService.shortCodeToNumeric(this.shortCodeValue);
    if (ScrBaseService.isInvalidShortCode(this.shortCodeValue)) {
      this.displayLocalizedError("scr.shortcode.invalid");
      const elmt = document.getElementById('messages');
      elmt?.scrollIntoView({ behavior: "smooth" });
      return;
    }
    this.model.brand = undefined;
    this.model.description = undefined;
    this.model.activityType = undefined;
    this.model.aggregatorId = undefined;
    this.model.sharedShortCode = false;
    this.brandClients = [];
    this.observe(this.shortCodesService.shortCodeLookup(this.searchShortCodeValue), {
      onSuccess: (res) => {
        this.apiMessage = undefined;
        if (res.messages && res.messages.length) {
          this.errorDisplayShortCode = this.shortCodeValue;

          this.preErrorMessage = this.translate.instant("scr.tc.shortcode", {}) as string;
          if (res.data.scStatus === 'Available') {
            this.apiMessage = `Short Code ${this.errorDisplayShortCode} is not currently leased. If you have concerns about content observed on this short code, please contact Customer Support at ${this.customerSupportPhone} for assistance.`;
            this.isDisplay = false;
          }
          else if (res.data.scStatus === 'Reserved') {
            this.apiMessage = `Short Code ${this.errorDisplayShortCode} is Reserved. If you have concerns about content observed on this short code, please contact Customer Support at ${this.customerSupportPhone} for assistance.`;
            this.isDisplay = false;
          } else if (res.data.scStatus === 'Pending') {
            this.apiMessage = `Short Code ${this.errorDisplayShortCode} has a new pending lease, but no payment has been made yet. If you have concerns about content observed on this short code, please contact Customer Support at ${this.customerSupportPhone} for assistance.`;
            this.isDisplay = false;
          } else {
            this.showData = true;
            this.isDisplay = true;
            this.isSearchDisabled = true;
            this.isInputDisabled = true;
            this.model.currentLease = res.data.company;
            this.model.currentLeasecompanyname = res.data.contentProvider?.company;
            this.model.contentProviderCompanyName = res.data.contentProvider?.company;
            if (res.data.aggregatorName !== 'To Be Determined') {
              this.model.aggregatorCompanyName = res.data.aggregatorName;
              const selectedAggregator = this.aggregators.find(agg => agg.name === res.data.aggregatorName);
              if (selectedAggregator) {
                this.model.aggregatorId = Number(selectedAggregator?.aggregatorId);
              }
            }
            this.model.applicationProviderCompanyName = res.data.applicationProvider;

            if (res.data.brands) {
              this.brandClients = res.data.brands.map(b => {
                return { label: b.company, value: b.company };
              });
              if (res.data.brands.length > 0) {
                this.model.brand = res.data.brands[0].company;
              }
            }
          }
        }
        return false;
      }
    });
  }

  getSCHistoy(shortCode: string) {
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['code-management', { outlets: { 'code-management-tab': ['code-history'] } }] } }], { state: { shortCode: shortCode } });
  }

  reportActivity({ form }: NgForm) {
    if (!this.model.aggregatorCompanyName || this.model.aggregatorCompanyName === undefined || this.model.aggregatorCompanyName === '') {
      form.controls['aggregator']?.setErrors({ notValid: true });
    }
    if (form.valid) {
      const req = new ReportSuspiciousActivityRequest();
      req.activityTypes = this.model.activityType;
      req.aggregatorId = this.model.aggregatorId;

      req.shortCode = Number(this.searchShortCodeValue);
      req.cpCompanyName = this.model.contentProviderCompanyName;
      req.applicationProvider = this.model.applicationProviderCompanyName;
      req.brand = this.model.brand;
      req.lesseeCompany = this.model.currentLease;
      req.description = this.model.description;
      req.sharedShortCode = this.model.sharedShortCode;
      this.shortCodesService.submitSuspiciousActivity(req).subscribe(data => {
        let message: string | undefined;
        if (data.messages && data.messages.length > 0) {
          message = data.messages[0].message;
        }
        this.router.navigate(['dashboard', { outlets: { 'navbar-tab': ['suspicious-activity', { outlets: { 'suspicious-activity-tab': ['carrier-reported-activities'] } }] } }], {state: {message}});
      });
    }
  }

  handleEnter(event: Event) {
    handleEnterKeyPress(event);
  }
  cancel(form: NgForm) {
    this.isDisplay = false;
    this.isInputDisabled = false;
    form.resetForm();
    this.router.navigate(['dashboard', { outlets: { 'navbar-tab': ['suspicious-activity', { outlets: { 'suspicious-activity-tab': ['report-suspicious-activity'] } }] } }]).then(() => {
      window.location.reload();
    });
  }

  onKeydown(event: KeyboardEvent) {
    let newLines = 0;
    const lines = 50;
    const target = event.target as HTMLTextAreaElement;
    if (target && target.value) {
      newLines = target.value.split('\n').length;

      //Validating lines are not greater than 6 and address does not contain | separator
      if (event.keyCode &&
        (event.keyCode == 13 &&
          newLines >= lines)
      ) {
        return false;
      }

      this.limitNumberOfCharactersInOneLine(event);

    }
    return true;
  }


  onKeyup(event: KeyboardEvent) {
    this.limitNumberOfCharactersInOneLine(event);
  }
  /**Limits the number of characters in one line to 35 */
  limitNumberOfCharactersInOneLine(event: KeyboardEvent) {
    const maxLength = 2000;
    const target = event.target as HTMLTextAreaElement;
    const allLines = target.value.split('\n');
    for (let i = 0; i < allLines.length; i++) {
      if (allLines[i].length > maxLength - 1) {
        allLines[i] = allLines[i].substring(0, maxLength);
      }
    }
    target.value = allLines.join('\n');
    this.model.description = allLines.join('\n');

  }

  onChangeSharedCheckbox(event: CheckboxChangeEvent) {
    this.model.sharedShortCode = event.checked;
  }

}
